// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SwitchInput.Common {
  --checkbox-size: 1.25rem;
  --radio-size: 1.25rem;
  --switch-size: 1.25rem;
}
.SwitchInput.Common .form-check-input[type=checkbox] {
  width: var(--checkbox-size);
  height: var(--checkbox-size);
}
.SwitchInput.Common .form-check-input[type=radio] {
  width: var(--radio-size);
  height: var(--radio-size);
}
.SwitchInput.Common.form-switch .form-check-input {
  width: calc(var(--switch-size) * 2);
  height: var(--switch-size);
}
.SwitchInput.Common:not(.form-switch) .form-check-input:focus {
  box-shadow: 0 0 0 0.25rem rgba(255, 155, 25, 0.25);
}
.SwitchInput.Common:not(.form-switch) .form-check-input:checked {
  background-color: var(--bs-secondary);
  border-color: var(--bs-secondary);
}`, "",{"version":3,"sources":["webpack://./src/common/SwitchInput/styles.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,qBAAA;EACA,sBAAA;AACF;AAEI;EACE,2BAAA;EACA,4BAAA;AAAN;AAEI;EACE,wBAAA;EACA,yBAAA;AAAN;AAII;EACE,mCAAA;EACA,0BAAA;AAFN;AAOM;EACE,kDAAA;AALR;AAOM;EACE,qCAAA;EACA,iCAAA;AALR","sourcesContent":[".SwitchInput.Common {\n  --checkbox-size: 1.25rem;\n  --radio-size: 1.25rem;\n  --switch-size: 1.25rem;\n\n  .form-check-input {\n    &[type='checkbox'] {\n      width: var(--checkbox-size);\n      height: var(--checkbox-size);\n    }\n    &[type='radio'] {\n      width: var(--radio-size);\n      height: var(--radio-size);\n    }\n  }\n  &.form-switch {\n    .form-check-input {\n      width: calc(var(--switch-size) * 2);\n      height: var(--switch-size);\n    }\n  }\n  &:not(.form-switch) {\n    .form-check-input {\n      &:focus {\n        box-shadow: 0 0 0 0.25rem rgba(255, 155, 25, 0.25);\n      }\n      &:checked {\n        background-color: var(--bs-secondary);\n        border-color: var(--bs-secondary);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
